import { jsx as _jsx } from "react/jsx-runtime";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers-pro";
import { TextField } from "@mui/material";
import moment from "moment";
import { useLocale } from "../LocaleProvider.js";
export const TimePickerMui = ({ disabled, label, value, onChange, ...otherProps }) => {
    const locale = useLocale();
    const format = moment.localeData(locale).longDateFormat("LT");
    return (_jsx(MuiTimePicker, { value: value, onChange: (date, value) => {
            onChange(null, value ?? null);
        }, label: label, disabled: disabled, views: ["hours", "minutes"] }));
};
export const TimePickerNative = ({ disabled, label, value, onChange, ...otherProps }) => {
    return (_jsx(TextField, { type: "time", label: label, disabled: disabled, value: value, onChange: (e) => {
            onChange(e, e.target.value);
        }, ...otherProps, slotProps: {
            htmlInput: {
                step: 60, // 1 min
            },
            inputLabel: { shrink: true },
        } }));
};
export const TimePicker = ({ browserHasInputTime, ...props }) => {
    return browserHasInputTime ? (_jsx(TimePickerNative, { ...props })) : (_jsx(TimePickerMui, { ...props }));
};
//# sourceMappingURL=TimePicker.js.map